import { render, staticRenderFns } from "./StockDetails.vue?vue&type=template&id=b8378206&scoped=true&"
import script from "./StockDetails.vue?vue&type=script&lang=ts&"
export * from "./StockDetails.vue?vue&type=script&lang=ts&"
import style0 from "./StockDetails.vue?vue&type=style&index=0&id=b8378206&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8378206",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
